import { render, staticRenderFns } from "./CompanyRepresentation.vue?vue&type=template&id=2d1a668e&scoped=true"
import script from "./CompanyRepresentation.vue?vue&type=script&lang=js"
export * from "./CompanyRepresentation.vue?vue&type=script&lang=js"
import style0 from "./CompanyRepresentation.vue?vue&type=style&index=0&id=2d1a668e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a668e",
  null
  
)

export default component.exports